import React from "react";

type Props = {};

const ImageUnloader: React.ComponentType<Props> = ({ children }) => {
  return <div>{children}</div>;
};

export default ImageUnloader;
